var _radialGradient, _path, _linearGradient, _circle, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Generalcontractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ZvG93iL2s_aXWH0fFsunUa",
    cx: 36.661,
    cy: 12.462,
    r: 13.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#787f85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#7a8187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#90989f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#9da5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a1aab3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ZvG93iL2s_aXWH0fFsunUa)",
    d: "M27.318,15.318c-0.352,0.352-18.648,18.648-19,19c-1.757,1.757-1.757,4.607,0,6.364 c1.757,1.757,4.607,1.757,6.364,0c0.352-0.352,18.648-18.648,19-19L27.318,15.318z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ZvG93iL2s_aXWH0fFsunUb",
    x1: 10.129,
    x2: 13.411,
    y1: 35.129,
    y2: 38.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 37,
    r: 2,
    fill: "url(#ZvG93iL2s_aXWH0fFsunUb)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ZvG93iL2s_aXWH0fFsunUc",
    x1: 29.131,
    x2: 41.661,
    y1: 7.002,
    y2: 19.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ZvG93iL2s_aXWH0fFsunUc)",
    d: "M40.425,13.838c-1.453,1.453-3.81,1.453-5.263,0c-1.453-1.453-1.453-3.81,0-5.263 c0.355-0.355,1.784-1.784,3.24-3.24c0.349-0.349,0.194-0.959-0.285-1.077c-1.18-0.29-2.45-0.351-3.771-0.102 c-3.874,0.73-6.895,3.972-7.297,7.893c-0.586,5.718,4.186,10.489,9.904,9.902c3.921-0.403,7.162-3.424,7.892-7.298 c0.249-1.321,0.188-2.59-0.102-3.77c-0.118-0.48-0.728-0.635-1.077-0.285C42.209,12.054,40.78,13.484,40.425,13.838z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ZvG93iL2s_aXWH0fFsunUd",
    x1: 4,
    x2: 37,
    y1: 22.4,
    y2: 22.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ZvG93iL2s_aXWH0fFsunUd)",
    d: "M37,36L12.5,11.7L10,8L5.4,6L4,7.4L6,12l3.7,2.5l24.5,24.3L37,36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#af2031",
    d: "M19.13,27.494c0.54,0.54,12.836,12.836,13.188,13.188c1.757,1.757,4.607,1.757,6.364,0 c1.757-1.757,1.757-4.607,0-6.364C38.33,33.966,26.034,21.67,25.494,21.13L19.13,27.494z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c94f60",
    d: "M23.494,19.13l-6.364,6.364c0.085,0.085,0.865,0.865,2,2l6.364-6.364 C24.359,19.995,23.579,19.215,23.494,19.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Generalcontractor);
export default __webpack_public_path__ + "static/media/icons8-generalcontractor.74d901451cdb6ebb0611f8e994b880c6.svg";
export { ForwardRef as ReactComponent };